export * from './insurer-footer';
